/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, Stack } from "@mui/material";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { AddLineWithIcon } from "components/add-line-with-icon";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { useTranslation } from "react-i18next";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ComponentLinkListItemContext } from "./component-link-list-context";

const defaultItem = Object.freeze({
    link: ""
});

/**
 * @param {object} props
 * @param {LinkListItem[]} props.links
 * @param {(updateItem: LinkListItem[]) => void} props.onItemChange
 * @param {import('react').ReactNode} props.children
 */
const ComponentLinkListEditWrapper = (props) => {
    
    const {
        links: initialLinks = [],
        onItemChange,
        children,
    } = props;

    const { t } = useTranslation();

    const {
        list,
        sortableMethods,
        controls,
    } = useSortableComponentList(
        initialLinks,
        defaultItem,
        onItemChange
    );

    const { addNewItem, addNewItemBelow, removeItem, updateItems } = controls;

    return (
        <>
            <div style={{ padding: "12px 0 24px 0" }}>
                <Button
                    size='medium'
                    variant='contained'
                    color={"primary"}
                    target='warning'
                    onClick={addNewItem}
                >
                    {t("commons.addListItem")}
                </Button>
            </div>
            <div className='simplicity-image-list'>
                <Stack direction='column'>
                    {isArrayNotEmpty(list) &&
                        list.map((item, index) => {
                            
                            const { guid } = item;
                            const ctx = {
                                index,
                                guid,
                                item,
                                list,
                                updateItems,
                                addNewItem,
                                removeItem,
                            };

                            return (
                                <ComponentLinkListItemContext.Provider
                                    key={`link-list-${guid}`}
                                    value={ctx}
                                >
                                    <SortableContent
                                        id={guid}
                                        index={index}
                                        sortableMethods={sortableMethods}
                                    >
                                        {children}
                                        <div>
                                            <PositionButtons
                                                index={index}
                                                list={list}
                                                handleUpdate={updateItems}
                                            />
                                            <RemoveIcon
                                                className='simplicity-composer-field-editor-remove'
                                                onDeleteItem={removeItem}
                                                index={index}
                                            />
                                        </div>
                                    </SortableContent>
                                    
                                    <AddLineWithIcon
                                        index={index}
                                        addNewItem={addNewItemBelow}
                                    />
                                    
                                </ComponentLinkListItemContext.Provider>
                            );
                        })}
                </Stack>
            </div>
        </>
    );
};
export default ComponentLinkListEditWrapper;


/**
 * @typedef {object} LinkListItem
 * @property {string} guid
 * @property {number} position
 */
